/**
 * Branded id types. The brand prevents mixing ids across entity kinds at the
 * type level (e.g. passing a SourceRecordId where an EntityId is expected).
 */
export type EntityId = string & { readonly __brand: 'EntityId' };
export type SystemId = string & { readonly __brand: 'SystemId' };
export type SourceRecordId = string & { readonly __brand: 'SourceRecordId' };
export type MutationLocalId = string & { readonly __brand: 'MutationLocalId' };

/** Generate a fresh opaque id using the platform crypto RNG. */
function uuid(): string {
  // crypto.randomUUID is available in Node >=19 and modern browsers.
  return globalThis.crypto.randomUUID();
}

export const newEntityId = (): EntityId => uuid() as EntityId;
export const newSourceRecordId = (): SourceRecordId => uuid() as SourceRecordId;
export const newMutationLocalId = (): MutationLocalId => uuid() as MutationLocalId;

/** Cast a known string to a typed id. Use only at trust boundaries (DB, input). */
export const asEntityId = (value: string): EntityId => value as EntityId;
export const asSystemId = (value: string): SystemId => value as SystemId;
export const asSourceRecordId = (value: string): SourceRecordId => value as SourceRecordId;
